<template>
    <div class="vld-parent">
        <LoadingV2 :fullPage="true" :loading="isLoading" :mensajeLoading="mensajeLoading"></LoadingV2>
        <a-layout v-if="!isLoading" class="layout-dashboard" id="layout-dashboard" :class="[navbarFixed ? 'navbar-fixed' : '', !sidebarCollapsed ? 'has-sidebar' : '', layoutClass]">
            <a-layout-sider 
                class="sider-primary"
                width="250px"
                collapsedWidth="0px"
                breakpoint="lg"
                v-model:collapsed="sidebarCollapsed"
                :trigger="null" 
                :class="['ant-layout-sider-' + sidebarColor, 'ant-layout-sider-' + sidebarTheme ]"
                    :theme="sidebarTheme"
                collapsible
                v-if="contentHeight == ''"
            >
                <DashboardSidebar 
                    :typeMenu="route.meta.typeRoute"
                    @toggleSidebar="toggleSidebar"
                />
            </a-layout-sider>
            <DashboardSidebar2 
                v-else
                :typeMenu="route.meta.typeRoute"
                :sidebarColor = "sidebarColor"
                :sidebarTheme = "sidebarTheme"
                :sidebarCollapsed="sidebarCollapsed"
                @toggleSidebar="toggleSidebar"
            />
            <a-layout>
                <a-layout-header ref="layoutHeader" >
                    <DashboardHeader 
                        v-if="typeMenu != undefined"
                        :typeMenu="typeMenu"
                        :sidebarCollapsed="sidebarCollapsed"
                        @toggleProfileDrawer="toggleProfileDrawer"
                        @toggleSidebar="toggleSidebar"
                        @redirect_logout="redirect_logout"
                    />
                </a-layout-header>
                <a-layout-content ref="layoutContent" :style="{ minHeight: `${contentHeight}`}">
                    <RouterView />
                </a-layout-content>
                <a-layout-footer ref="layoutFooter">
                    <DashboardFooter />
                </a-layout-footer>
            </a-layout>
        </a-layout>
    </div>
    
</template>
<script setup>
import { computed, reactive, ref, onMounted, onBeforeMount, nextTick } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { addIcons } from "oh-vue-icons";
import { RiBillLine, BiCreditCardFill, MdPayments, MdCreditscoreRound, GiPayMoney, RiSecurePaymentFill, HiDocumentText  } from "oh-vue-icons/icons";
import { FaFlag, RiZhihuFill } from "oh-vue-icons/icons";
import { FcPlanner, CoGroup, CoObjectUngroup } from "oh-vue-icons/icons";
import { MdMobilescreenshareOutlined  } from "oh-vue-icons/icons";
import { CoNewspaper } from "oh-vue-icons/icons";
import { isLoading, contentHeight, getContentHeight, toggleSidebar, setupResizeListener, redirect_logout, toggleProfileDrawer, fetchProfileData, inteval_profile } from '@/plugins/layouts_utils'
import LoadingV2 from '@/components/Widgets/LoadingV2';
import DashboardSidebar from '../components/Sidebars/DashboardSidebar';
import DashboardFooter from '../components/Footers/DashboardFooter';
import DashboardSidebar2 from '../components/Sidebars/DrawerMenu';
import DashboardHeader from '../components/Headers/DashboardHeader';

const route = useRoute();
// route.value = useRoute();
const router = useRouter();
const navbarFixed  = ref(true);
const sidebarCollapsed = ref(false)
const mensajeLoading = ref("Cargando datos...");
const layoutClass = route.meta.layoutClass ? route.meta.layoutClass : 'dashboard'
const sidebarColor = 'primary';
const sidebarTheme = 'light';
const typeMenu = ref(null)

onBeforeMount( async () => {
    addIcons(RiBillLine, BiCreditCardFill, MdPayments, MdCreditscoreRound, GiPayMoney, RiSecurePaymentFill, HiDocumentText, FaFlag, RiZhihuFill, MdMobilescreenshareOutlined, CoNewspaper, FcPlanner, CoGroup, CoObjectUngroup )
    if (!route.meta.mySystem || route.meta.mySystem.length == 0) {
        console.log("perdi el login")
        // console.log(route.meta)
        if (route.meta.typeUser != "Portal") { 
            // localStorage.removeItem('DataGPSContruccion'); 
            await fetchProfileData(route) 
            if (route.meta.mySystem.length == 0) {
                console.log("NO AUTORIZADO")
                router.push("/401");
            }  else {
                if (localStorage.getItem('tmpUser')) {
                    route.meta.typeRoute = localStorage.getItem('typeRouter');
                } else {
                    console.log("NO AUTORIZADO")
                    router.push("/401");
                }
            }      
        } else {
            console.log("NO AUTORIZADO")
            router.push("/401")
        }    
    } else {
        // console.log("mantuve login")
        // console.log(route.meta)
        if (route.meta.typeRoute == undefined) {
            route.meta.typeRoute = localStorage.getItem('typeRouter');
        } else {
            localStorage.setItem('typeRouter', route.meta.typeRoute);
        }
        localStorage.setItem('token_portal', true);
        localStorage.setItem('authCRM', route.meta.authCRM);
    }
    isLoading.value = false;
    typeMenu.value = route.meta.typeRoute
    // console.log(typeMenu)  
})

onMounted(async () => {
    getContentHeight();
    // const interval2 = inteval_profile();
});

nextTick(() => {
    setupResizeListener();
}) 

function obtenerClavesLocalStorage() {
  const claves = [];
  for (let i = 0; i < localStorage.length; i++) {
    claves.push(localStorage.key(i));
  }
  return claves;
}
</script>